module.exports = __webpack_public_path__ + "img/thumbnail_AfricanElephant_j_normal.a307ee30.png";